// extracted by mini-css-extract-plugin
export default {"accordionSection":"accordionSection---F9RWj","finePolicyForm":"finePolicyForm---z29vI"};